import { Cross1Icon } from "@radix-ui/react-icons";
import { VFC } from "react";
import { Dialog } from "src/components/dialog";
import { nodeDefs } from "src/nodes";
import { NodeInstance, NodeType } from "src/types/node.types";
import { NodeTypeSelection } from "./node-type-selection";

export interface CreateNodeDialogProps {
  onCreate: (nodes: NodeInstance[]) => void;
  onClose: VoidFunction;
}

export const CreateNodeDialog: VFC<CreateNodeDialogProps> = (props) => {
  const onSelectHandler = (nodeType: NodeType) => {
    const nodeDef = nodeDefs[nodeType];
    const instance = nodeDef.create();
    const additionalNodes = nodeDef.autoNodes?.(instance) || [];
    props.onCreate([instance, ...additionalNodes]);
  };

  return (
    <Dialog.Root open>
      <Dialog.Portal>
        <Dialog.Overlay onClick={props.onClose} />
        <Dialog.Content onEscapeKeyDown={props.onClose}>
          <Dialog.ContentHeader>
            <Dialog.Title>Add new node</Dialog.Title>
            <Dialog.Description>
              Choose a type for your new node
            </Dialog.Description>
            <Dialog.Close onClick={props.onClose} aria-label="Close">
              <Cross1Icon />
            </Dialog.Close>
          </Dialog.ContentHeader>
          <Dialog.ContentBody>
            <NodeTypeSelection onChange={onSelectHandler} />
          </Dialog.ContentBody>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
